import React from 'react';
import PropTypes from 'prop-types';
import { SelectTree } from '@tencent/spaui-business';
import { connect } from 'react-redux';
import _ from 'lodash';
import './IndustryInfo.scoped.less';

const extraIndustryData = [
  {
    className: '',
    desc: '未知行业',
    value: 0,
  },
  {
    className: '',
    desc: '空',
    value: 'null',
  },
];

class IndustrySelect extends React.Component {
  static propTypes = {
    rootList: PropTypes.arrayOf(PropTypes.shape({
      industryId: PropTypes.number.isRequired,
      displayName: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      className: PropTypes.string,
    })).isRequired,
    industryList: PropTypes.arrayOf(PropTypes.shape({
      industryId: PropTypes.number.isRequired,
      displayName: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      className: PropTypes.string,
    })).isRequired,
    withDeprecatedMark: PropTypes.bool, // 废弃行业标记
    deprecatedDisabled: PropTypes.bool, // 废弃行业禁用
    onChange: PropTypes.func,
    level1Disable: PropTypes.bool, // 是否禁用一级行业
  }

  state = {
    searchValue: '',
    searchValueData: undefined,
  }

  render() {
    const { rootList, industryList, value, onChange, props = {}, level1Disable, extraIndustry = false, search } = this.props;
    const data = _.map(rootList, (parent) => {
      return {
        value: level1Disable ? '' : parent.industryId,
        desc: parent.label,
        isdisabled: parent.status,
        className: parent.className,
        'data-report': `industry-select-tree-options-${parent.label}`,
        options: _.map(
          _.filter(industryList, (industry) => industry.parentId === parent.industryId),
          (child) => {
            return {
              value: child.industryId,
              desc: child.label,
              className: child.className,
              isdisabled: child.status,
              'data-report': `industry-select-tree-options-${child.industryId}`,
            };
          },
        ),
      };
    });
    // 前端添加额外行业选项
    if (extraIndustry) {
      data.push(...extraIndustryData);
    }
    const { searchValue, searchValueData } = this.state;
    return (
      <SelectTree
        data-report='industry-select-tree'
        {...props}
        className="industrySelect"
        clearable
        data={data}
        value={value}
        onChange={onChange}
        canSelected={this.canSelected}
        search={search}
        onSearch={this.onSearch}
        searchValue={searchValue}
        searchValueData={searchValueData}
      />
    );
  }

  canSelected = (treeNode, defaultAllowSelected) => {
    const { deprecatedDisabled = false, level1Disable } = this.props;
    if (treeNode.deepLevel === 1) {
      if (level1Disable) return false;
      return true;
    }
    if (!deprecatedDisabled) return true;
    if (treeNode.isdisabled === 'active' || treeNode.isdisabled === 'pre_deprecated') {
      return true;
    } if (treeNode.isdisabled === 'deprecated') {
      return false;
    }
  }

  onSearch = (e, value) => {
    value = value.trim();
    const { industryList, deprecatedDisabled } = this.props;
    const searchValueData = _.map(
      _.filter(industryList, (v) => _.includes(v.label, value)),
      (industry) => {
        return {
          value: industry.industryId,
          label: industry.label,
          disabled: deprecatedDisabled && industry.status === 'deprecated',
        };
      },
    );
    this.setState({ searchValue: value, searchValueData: !value ? undefined : searchValueData });
  }
}

function mapStateToProps(state, ownProps) {
  const statusNameMap = {
    active: '',
    pre_deprecated: '（预废弃）',
    deprecated: '（废弃）',
  };
  const industryList = _.map(_.map(state.industryList.items, (industryId) => state.industryRepo[industryId]), (item) => {
    const label = `${item.displayName}${statusNameMap[item.status] || ''}`;
    return {
      ...item,
      label: ownProps.withDeprecatedMark ? label : item.displayName,
      className: ownProps.deprecatedDisabled && item.status === 'deprecated' ? 'deprecated' : '',
    };
  });
  return {
    rootList: _.filter(industryList, (industry) => industry.level === 1),
    industryList,
  };
}

export default connect(mapStateToProps)(IndustrySelect);
